import React from "react";
import { UseFormRegister, FieldErrors, UseFormSetValue } from "react-hook-form";
import ClientPermissionMetrix from "./ClientPermissionMetrix";

type CreatRoleModalProps = {
  register: UseFormRegister<any>;
  errors: FieldErrors;
  setValue: UseFormSetValue<any>;
  defaultValues?: any;
  readOnly?: boolean;
};

const CreateClientModal = ({
  register,
  errors,
  setValue,
  defaultValues,
  readOnly,
}: CreatRoleModalProps) => {
  return (
    <div className="w-full overflow-y-auto h-[calc(100vh-14rem)] overflow-hidden space-y-4">
      <ClientPermissionMetrix
        register={register}
        errors={errors}
        setValue={setValue}
        defaultPermissions={defaultValues?.permissions || []}
        readOnly={readOnly}
        clientId={defaultValues?.id}
      />
    </div>
  );
};

export default CreateClientModal;
